export class Tokens {
  access: string;
  refresh: string;

  constructor({ access_token, refresh_token }) {
    this.access = access_token;
    this.refresh = refresh_token;
  }
}
